import { defineComponent as _defineComponent } from 'vue'
import { ref, PropType } from "vue";
    import DataTable from "primevue/datatable";
    import GridModule from "@/composables/modules/controls/gridModule";
    import GridConfig from "@/models/controls/Grid/gridConfig";
    import DeleteModel from "@/models/common/deleteModel";
    import commonModule from "@/composables/modules/commonModule"
    import UrlConstants from "@/utils/urlconstants";
    import requestMethod from "@/composables/api/requestMethod";

    import importModel from "@/models/complaint/importModel";
import { useAuthDataStore } from "@/store/useAuthDataStore";

    
export default /*@__PURE__*/_defineComponent({
  __name: 'commonGrid',
  props: {
        config: { type: Object as PropType<GridConfig>, required: true },
        filename: { type: String, required: true },
        hideExportBtn: { type: Boolean, default: true },
        hideMultiDispatch: { type: Boolean, default: false },
        hideNotificationReadBtn: { type: Boolean, default: false },
        hideFilter: { type: Boolean, default: false },
        hideAssignedToBtn: { type: Boolean, default: false },
        IsPageStateClear: { type: Boolean, default: false },
        Isscrollable: { type: Boolean, default: false },
        Ispaginator: { type: Boolean, default: false },
        IsscrollHeight: { type: String, default: "" },
        showFooter: { type: Boolean, default: false },
        NumnerOfRow: { type: Number, default: 15 },
        AdvSearchBtnClass: { type: String, default: "" },
        IsAdvFilter: { type: Boolean, default: true },
        IsOnlyGrid: { type: Boolean, default: false },
        hidecomplaintImportBtn: { type: Boolean, default: false },
        callBack: Function,
        IsInItData: { type: Boolean, default: true },
        IsShowFilterBox: { type: Boolean, default: true },
        ExtraDatacallBack:Function,
        resizableColumns: { type: Boolean, default: false },
        columnResizeMode:{ type: String, default: "fit" },
        selectionMode:{ type: String, default: "" },
        paginatorTemplate:{type:String,default:"RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"},
        hideDeletBtn: { type: Boolean, default: true },
    },
  emits: ["update:modelValue", "update:title"],
  setup(__props, { expose: __expose, emit: __emit }) {

    const { DeleteData, PostData,ImportData } = new commonModule();
    const IsNullEmptyOrUndefined = (obj: any) => {
        return !obj || obj == "";
    }
    const emit = __emit;
    const Props = __props;
    const {
        loadLazyData,
        onDropDownSort,
        favourite,
        selectedRecords,
        dt,
        loading,
        resultData,
        totalRows,
        activeFilters,
        onPage,
        onSort,
        initData,
        //sidebarVisible,
        lazyParams,
        selectedColumns,
        columns,
        onChange,
        onDelete,
        reloadGrid,
        isFilter,
        //useLang,
        filtersCount,
        curPagePermission,
        ExportExcel,
        hideOnlyGrid,
        hideActiveBtn,
        hideDeactiveBtn,
        onRowSelect,
        onRowDubleClick,
        route, first, last, SelectedRecordExport, ApplyFilter, selectedvaluefilter, AdvanceSearchModel, selectedvaluefilterTitle, OpenAdvanceSearchModel,
        removeFilterItems, clearFilterItems,reinitGrid
    } = new GridModule(Props);
    const responsiveLayoutValue = ref("scroll");
    const MenuViewItem = ref(true);

    const Remove = () => {
        TobeDeleteRecords.value.Ids = [];
        if (selectedRecords.value.length > 0) {
            for (let i = 0; i < selectedRecords.value.length; i++)
                TobeDeleteRecords.value.Ids.push(selectedRecords.value[i]["Id"]);
            DeleteData(Props.config.deleteApi, TobeDeleteRecords.value, (data: any) => {
                loadLazyData();
                RemoveConfirmation.value = false;
                RemoveRecords.value = false;
            }, (data: any) => {
                RemoveConfirmation.value = false;
                RemoveRecords.value = false;
            });
        }
    }
    const CancelEvent = () => {
        selectedRecords.value = [];
        RemoveConfirmation.value = false;
        RemoveRecords.value = false;
    }
    const RemoveConfirmation = ref(false);
    const RemoveRecords = ref(false);
    const TobeDeleteRecords = ref<DeleteModel>({ Ids: [], IsDelete: false });
    const Removeconfirm = () => {
        RemoveConfirmation.value = true;
    }
    const SingleDelete = (id: any) => {
        selectedRecords.value = [];
        selectedRecords.value.push({ Id: id });
        Removeconfirm();
    }

    const getSlectedItems = () => {
        // emit("update:modelValue", value);
        if (typeof Props.callBack != "undefined") {
            Props.callBack(selectedRecords.value);
        }
    }

    const multiDispacth = () => {
        // emit("update:modelValue", value);
        if (typeof Props.ExtraDatacallBack != "undefined") {
            Props.ExtraDatacallBack(selectedRecords.value);
        }
    }

    const getSlectedItemsForNotification = (ReloadGrid:any) => {
        // emit("update:modelValue", value);
        if (typeof Props.callBack != "undefined") {
            Props.callBack(selectedRecords.value,ReloadGrid);
        }
    }

    //
     const importRecords = ref<importModel>({ Ids: [], BUId:0, CountryId:0 });
    const authLogin = useAuthDataStore().getAuth as any;
    const ImportComplaint = async () => {
        TobeDeleteRecords.value.Ids = [];
        importRecords.value.Ids = []
        importRecords.value.BUId = 0
        importRecords.value.CountryId = 0
        if (selectedRecords.value.length > 0) {
            for (let i = 0; i < selectedRecords.value.length; i++)
                importRecords.value.Ids.push(selectedRecords.value[i]["Id"]);
              
              if((authLogin.BUs || []).length > 0)
              {
                importRecords.value.BUId = authLogin.BUs[0]
              }
              importRecords.value.CountryId = authLogin.CountryId
             ImportData(UrlConstants.apiSaveComplaint, importRecords.value, (data: any) => {

                loadLazyData();
            }, (data: any) => {
                RemoveConfirmation.value = false;
                RemoveRecords.value = false;
            },true);
        }
    }

    __expose({
        selectedRecords,
        reloadGrid,
        onDropDownSort,
        curPagePermission,
        MenuViewItem,
        hideOnlyGrid,
        SingleDelete,
        initData,
        ApplyFilter,
        ExportExcel,
        reinitGrid,
        clearFilterItems,
        lazyParams
    });


const __returned__ = { DeleteData, PostData, ImportData, IsNullEmptyOrUndefined, emit, Props, loadLazyData, onDropDownSort, favourite, selectedRecords, dt, loading, resultData, totalRows, activeFilters, onPage, onSort, initData, lazyParams, selectedColumns, columns, onChange, onDelete, reloadGrid, isFilter, filtersCount, curPagePermission, ExportExcel, hideOnlyGrid, hideActiveBtn, hideDeactiveBtn, onRowSelect, onRowDubleClick, route, first, last, SelectedRecordExport, ApplyFilter, selectedvaluefilter, AdvanceSearchModel, selectedvaluefilterTitle, OpenAdvanceSearchModel, removeFilterItems, clearFilterItems, reinitGrid, responsiveLayoutValue, MenuViewItem, Remove, CancelEvent, RemoveConfirmation, RemoveRecords, TobeDeleteRecords, Removeconfirm, SingleDelete, getSlectedItems, multiDispacth, getSlectedItemsForNotification, importRecords, authLogin, ImportComplaint, get DataTable() { return DataTable } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})